import { LessonPreview } from "./LessonPreview";
import { GET_LESSON } from "./__mocks__";

export const LessonPreviewParent: React.VFC = () => {
  return <LessonPreview lesson={GET_LESSON} />;
};
